<div class="snackBar">
  <div class="svg-container">
    <svg width="86" height="85" viewBox="0 0 86 85" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="86" height="85">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.00012207H85.4869V85H0V0.00012207Z" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M72.1529 21.9385C80.3947 33.2636 86.7984 45.1815 85.2567 56.625C83.7152 68.0686 74.2875 79.0972 63.1404 83.129C51.9933 87.161 39.1859 84.1964 26.7937 78.8007C14.4607 73.405 2.60203 65.5783 0.408186 55.6171C-1.84491 45.6558 5.56673 33.5007 14.3421 22.1164C23.1175 10.6728 33.3159 0.00012207 43.455 0.00012207C53.6534 0.00012207 63.8519 10.6728 72.1529 21.9385Z"
          fill="#193356" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56.6588 41.3205L46.6843 32.0602L40.9037 59.4673L53.7685 55.0241L56.0525 55.5058L54.1256 64.6416L58.6935 65.605L60.6203 56.4692L62.9043 56.951C65.4166 57.4809 67.9056 55.8588 68.4355 53.3465L69.399 48.7786C69.9289 46.2663 68.3069 43.7773 65.7945 43.2474L56.6588 41.3205Z"
        fill="#FCCC04" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.2363 51.2455L41.4589 35.9659C38.9627 37.3956 37.06 39.8569 36.4193 42.8945C35.7786 45.9322 36.5253 48.9523 38.2363 51.2455ZM54.9939 39.6556L45.0194 30.3953L39.2389 57.8023L52.1036 53.3592L54.3875 53.8409L52.4607 62.9766L57.0286 63.94L58.9554 54.8044L61.2394 55.286C63.7516 55.8159 66.2407 54.1939 66.7706 51.6816L67.7341 47.1137C68.2639 44.6014 66.642 42.1124 64.1296 41.5825L54.9939 39.6556Z"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.0554 37.4795L21.0919 42.0473L30.2276 43.9742L31.1911 39.4064L22.0554 37.4795Z"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.6097 51.2114C28.0703 52.3934 24.7625 53.9382 22.145 55.1514C22.8032 56.5545 23.4567 57.9805 24.115 59.3837C26.7326 58.1706 30.0403 56.6258 32.5748 55.4667C31.9166 54.0635 31.2632 52.6374 30.6097 51.2114Z"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M34.4634 32.9399C35.6322 31.9221 36.806 30.8815 37.9749 29.8637C36.1291 27.7568 33.727 25.0078 31.8224 22.8408C30.6535 23.8585 29.4798 24.8992 28.3109 25.9171C30.2108 28.1069 32.6176 30.833 34.4634 32.9399Z"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.51197 25.7204C7.0714 24.9253 7.63036 24.1156 8.18979 23.3205C6.74994 22.3138 4.87495 20.9993 3.39018 19.9648C2.83067 20.7599 2.27171 21.5696 1.71228 22.3647C3.19752 23.4138 5.07204 24.7137 6.51197 25.7204Z"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.3379 82.4212C14.9226 82.8991 15.5186 83.3775 16.1033 83.8554C16.9639 82.7962 18.0873 81.417 18.9719 80.3246C18.3872 79.8466 17.7911 79.3683 17.2064 78.8903C16.3105 79.9823 15.1984 81.3619 14.3379 82.4212Z"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M75.3292 19.6595C76.0449 20.3175 76.7751 20.9768 77.4907 21.6349C78.676 20.3379 80.2229 18.6496 81.4415 17.3118C80.7259 16.6539 79.9957 15.9944 79.28 15.3364C78.0468 16.6728 76.5145 18.3625 75.3292 19.6595Z"
        fill="#193356" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.5092 78.9971C77.9627 79.4664 77.4139 79.9462 76.8673 80.4155C77.7184 81.4007 78.826 82.6861 79.7042 83.6993C80.2508 83.2301 80.7996 82.7501 81.3462 82.2809C80.4702 81.257 79.3603 79.9823 78.5092 78.9971Z"
        fill="#193356" />
    </svg>
  </div>
  <div class="text-container">
    <div class="title">Information.</div>
    <div class="message">
      {{ data.message }}
    </div>
    <button mat-icon-button class="close-icon" (click)="close()">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
  <div class="determinate-bar">
    <ng-container *ngIf="indeterminate">
      <mat-progress-bar class="snack-bar-radius" [ngClass]="'primary'" mode="indeterminate"> </mat-progress-bar>
    </ng-container>
    <ng-container *ngIf="!indeterminate">
      <mat-progress-bar class="snack-bar-radius" [ngClass]="'primary'" mode="determinate" [value]="countPercent"> </mat-progress-bar>
    </ng-container>
  </div>
</div>
